export interface Example {
  id: string;
  label: string;
  prompt: string;
}

/** The example chips. A recording made with `--chip <id>` must use that chip's prompt verbatim. */
export const EXAMPLES: readonly Example[] = [
  { id: 'pricing', label: 'Pricing section', prompt: 'A pricing section with three tiers and a highlighted "Pro" plan' },
  { id: 'music-player', label: 'Music player card', prompt: 'A glassmorphic music player card with play controls and a progress bar' },
  { id: 'testimonials', label: 'Testimonial carousel', prompt: 'A responsive testimonial carousel with avatars and star ratings' },
  { id: 'stats-header', label: 'Stats dashboard header', prompt: 'An animated stats dashboard header with four KPI cards' },
];
